// AdminCreatePlayer — legacy URL adapter.
//
// Phase 13: the create-player flow now lives in CreatePlayerModal,
// triggered from the Players list. This page exists only to keep the
// old route (/people/players/new) working — it auto-opens the same
// modal and routes back when done.

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '@baaligames/shared-ui/admin/lib/adminAuth';
import CreatePlayerModal from '@baaligames/shared-ui/admin/components/CreatePlayerModal';

export default function AdminCreatePlayer() {
  const { admin } = useAdminAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(true);

  // If the auth context hasn't loaded yet just wait — useAdminAuth
  // loading state is handled by the shell, so by the time we render
  // here `admin` should be present.
  useEffect(() => {
    if (!open) nav('/people/players', { replace: true });
  }, [open, nav]);

  if (!admin) return null;

  return (
    <CreatePlayerModal
      mode="agent"
      callerAgentId={admin.id}
      onClose={() => setOpen(false)}
      onCreated={() => setOpen(false)}
    />
  );
}
